var usualPageSetup = require('../modules/usualPageSetup');

function init() {
    'use strict';
    usualPageSetup.init();
}

module.exports.init = init;



//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/pages/default.js
// module id = bsvw
// module chunks = 16